import { type ExprNode, num, add, mul, pow, variable } from './node';
import { derivative } from './derivative';
import { simplify } from './simplify';
import { evaluate } from './evaluate';

/** Taylor coefficients a_k = f^(k)(center) / k!, for k = 0..order. */
export function taylorCoefficients(
  f: ExprNode,
  varName: string,
  center: number,
  order: number,
): number[] {
  const coeffs: number[] = [];
  let current = f;
  let factorial = 1;
  for (let k = 0; k <= order; k++) {
    if (k > 0) factorial *= k;
    coeffs.push(evaluate(current, { [varName]: center }) / factorial);
    current = simplify(derivative(current, varName));
  }
  return coeffs;
}

/** The Taylor polynomial P_n as an ExprNode: Σ a_k · (x − center)^k. */
export function taylorPolynomial(
  f: ExprNode,
  varName: string,
  center: number,
  order: number,
): ExprNode {
  const coeffs = taylorCoefficients(f, varName, center, order);
  const base = (): ExprNode =>
    center === 0 ? variable(varName) : add([variable(varName), num(-center)]);
  return simplify(add(coeffs.map((c, k) => mul([num(c), pow(base(), num(k))]))));
}
